import { useMemo } from 'react';
import { FormControls } from '@elementary/common-ui/components';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm, ColumnResource } from 'shared/types';
import { getConditionalSeverityString } from 'testManagement/utils/utils';

type Props = {
  watch: UseFormWatch<AddTestForm>;
  columnsResourcesData: ColumnResource[];
};

const ColumnsAcceptedValuesConfig = ({
  watch,
  columnsResourcesData,
}: Props) => {
  const values = watch('values');
  const resources = watch('resources');

  const target = useMemo(() => {
    if (resources.length > 1) {
      return null;
    }
    const resource = resources[0];
    return columnsResourcesData.find((col) => col.id === resource);
  }, [columnsResourcesData, resources]);

  const { warnIf, errorIf } = getConditionalSeverityString(watch('severity'));

  return (
    <>
      <SeverityRenderer
        severity={watch('severity')?.type || 'error'}
        warnIf={warnIf}
        errorIf={errorIf}
      />

      {target ? (
        <FormControls.FormText>
          The <b>{target.name}</b> column in the <b>{target.model_name}</b>{' '}
          table should be one of the following values:{' '}
          <b>{values?.join(', ')}</b>
        </FormControls.FormText>
      ) : (
        <FormControls.FormText>
          The column should be one of the following values:{' '}
          <b>{values?.join(', ')}</b>
        </FormControls.FormText>
      )}
    </>
  );
};

export default ColumnsAcceptedValuesConfig;
